import { DataGrid, Column, FilterRow } from "devextreme-react/data-grid";
import { Badge } from "react-bootstrap";

const LeaveDetailGrid = ({ dataSource, onDeleteRow }) => {
  const calculatePeriode = (row) => {
    const start = new Date(row.start_periode);
    const end = new Date(row.end_periode);

    return `${start.getFullYear()}-${end.getFullYear()}`;
  };

  const renderDay = ({ value }) => {
    const bg = value >= 0 ? "primary" : "danger";

    return (
      <Badge className="w-full p-2" bg={bg}>
        {value}
      </Badge>
    );
  };

  const renderStart = ({ value }) => {
    const date = new Date(value);
    return (
      <Badge className="w-full p-2 " bg="danger">
        {date.toDateString()}
      </Badge>
    );
  };
  const renderEnd = ({ value }) => {
    const date = new Date(value);
    return (
      <Badge className="w-full p-2" bg="success">
        {date.toDateString()}
      </Badge>
    );
  };

  const renderDeleteButton = ({ value }) => {
    return value === null ? null : (
      <button
        className=" text-red-500 text-base text-center font-extrabold "
        onClick={() => onDeleteRow(value)}
      >
        <i className="dx-icon-trash  " />
      </button>
    );
  };

  return (
    <div>
      <DataGrid
        dataSource={dataSource}
        allowColumnReordering={true}
        showBorders={true}
        rowAlternationEnabled={true}
      >
        <FilterRow visible={true} />
        <Column
          allowFiltering={false}
          width="auto"
          dataField="id"
          caption=""
          calculateCellValue={(row) => (row.can_delete ? row.id : null)}
          cellRender={renderDeleteButton}
        />
        <Column width="auto" dataField="employee_id" caption="Kode Pegawai" />
        <Column dataField="employee_name" caption="Nama Pegawai" />
        <Column
          dataField="date"
          dataType="date"
          format="dd MMM yy"
          caption="Tanggal"
        />
        <Column
          dataField="day"
          width="auto"
          cellRender={renderDay}
          caption="Hari"
        />
        <Column
          dataField="start_date"
          dataType="date"
          format="dd MMM yy"
          cellRender={renderStart}
          caption="Dari"
        />
        <Column
          dataField="end_date"
          dataType="date"
          format="dd MMM yy"
          caption="Sampai"
          cellRender={renderEnd}
        />

        <Column
          width="auto"
          caption="Periode"
          calculateCellValue={calculatePeriode}
        />
        <Column caption="Keterangan" dataField="desc" />
      </DataGrid>
    </div>
  );
};

export default LeaveDetailGrid;
